import type { SalesPoint } from 'Services/ServiceProviderManagement/Features/SalesPoint/types'
import type { FetchListParams } from 'Services/ServiceProviderManagement/types'

export enum DeviceTabType {
  DETAILS = 'details',
  ALLOWED_API_CLIENTS = 'allowed_api_clients'
}

export interface Device {
  owner_client: string
  client_read: string[]
  client_write: string[]
  pta: string
  device_id: string
  name: string
  sales_point_id: string
  created_timestamp: Date
  modified_timestamp: Date
  last_modified_client: string
  sales_point: SalesPoint
  active: boolean
  activity_end_date: Date | null
  source: string
  directory_alias: string | null
  machine_uuid: string | null
}

export interface FetchDeviceListParams extends FetchListParams {}
